import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {Article} from "../../models/article.model";
import {api_url_replace} from "../../defines/protocol";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {BoardService} from "../../services/board/board.service";
import {Subscription} from "rxjs";
import {finalize} from "rxjs/operators";

@Component({
  selector: 'app-board-detail',
  // changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './board-detail.component.html',
  styleUrls: ['./board-detail.component.scss']
})
export class BoardDetailComponent implements OnInit, OnDestroy {
  @Input() article_no?: number;
  @Output() close = new EventEmitter<number>();

  protected readonly ApiUrlReplace = api_url_replace;

  protected article?: Article;
  private article$: Subscription | null = null;

  protected is_loading: boolean = false;

  constructor(
    private boardSvc: BoardService,
    private globalEventSvc: GlobalEventService,
  ) {
  }

  ngOnInit() {
    this.loadArticle();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['article_no']) {
      this.loadArticle();
    }
  }

  ngOnDestroy() {
    if (this.article$) {
      this.article$.unsubscribe();
      this.article$ = null;
    }
  }

  private loadArticle(): void {
    if (this.article$) {
      this.article$.unsubscribe();
      this.article$ = null;
    }
    this.is_loading = true;
    this.article$ = this.boardSvc.GetDetail(this.article_no!).pipe(
      finalize(() => {
        this.article$ = null;
        this.is_loading = false;
      }),
    ).subscribe(
      article => {
        // console.warn('BoardDetailComponent::GetDetail() = ', article);
        this.article = new Article(article);
      }
    );
  }

  protected onClose($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    this.close.emit(this.article!.no);
  }
}
